import { logError } from './logUtils'

let initialized = false

export const initIntercom = ({
  appId,
  apiBase = 'https://api-iam.intercom.io',
  name,
  email,
  createdAt,
  properties = {}
}) => {
  if (initialized) {
    return
  }

  window.Intercom('boot', {
    api_base: apiBase,
    app_id: appId,
    name,
    email,
    created_at: createdAt,
    hide_default_launcher: true,
    ...properties
  })

  initialized = true

  // Activate the messenger by briefly showing/hiding it
  // This enables notifications to appear even when the launcher is hidden
  activateMessengerForNotifications()
}

const activateMessengerForNotifications = () => {
  // Create a one-time onShow handler that immediately hides the messenger
  // This activates Intercom's notification system without visible UI flash
  let activationComplete = false

  const hideOnFirstShow = () => {
    if (!activationComplete) {
      activationComplete = true
      window.Intercom('hide')
      // Remove the callback so it doesn't interfere with future legitimate shows
      window.Intercom('onShow', () => {})
    }
  }

  window.Intercom('onShow', hideOnFirstShow)

  // Trigger the show to activate notifications
  setTimeout(() => {
    window.Intercom('show')
  }, 100)
}

export const showIntercomHelpWidget = () => {
  window.Intercom('update', {
    hide_default_launcher: false
  })
}

export const hideIntercomHelpWidget = () => {
  window.Intercom('update', {
    hide_default_launcher: true
  })
}

export const openIntercomHelpPopup = () => {
  if (initialized) {
    window.Intercom('show')
  } else {
    logError('Tried to show intercom chat before it was initialized')
  }
}

export const isInitialized = () => initialized
